import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './OfflineBanner.scss';

const OfflineBanner = () => {
    const { t } = useTranslation();
    const [offline, setOffline] = useState(() => (
        typeof navigator !== 'undefined' && navigator.onLine === false
    ));

    useEffect(() => {
        const onOffline = () => setOffline(true);
        const onOnline = () => setOffline(false);
        window.addEventListener('offline', onOffline);
        window.addEventListener('online', onOnline);
        return () => {
            window.removeEventListener('offline', onOffline);
            window.removeEventListener('online', onOnline);
        };
    }, []);

    if (!offline)
        return null;

    return (
        <>
            <div className="OfflineBanner" role="status">
                {t('app.offline_banner')}
            </div>
            <div className="OfflineBanner-spacer" aria-hidden="true" />
        </>
    );
};

export default OfflineBanner;
